import { type IRootState } from '@app/types';

const root = (state: IRootState) => state.bootstrapReducer;

export const selectIsAppReady = (state: IRootState) => root(state).ready;
